import { FilledButton, OutlinedButton } from '@/components/UI/Button';
import { Box, Dialog, styled, Typography } from '@mui/material';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: '16px',
    backgroundColor: theme.palette.common.white,
    padding: '40px',
    maxWidth: '480px',
    width: '100%',
  },
}));

export const Message = styled(Typography)(() => ({
  color: '#1A1A1A',
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '150%',
  textAlign: 'center',
}));

export const WarningBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  backgroundColor: '#FFFAEA',
  border: '1px solid #F2E2B2',
  borderRadius: '8px',
  padding: '12px 16px',
  marginTop: '24px',
  color: '#344054',
  fontSize: '13px',
  lineHeight: '140%',

  '& span': {
    color: '#EF9A11',
  },
}));

export const ButtonsContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  gap: '24px',
  marginTop: '32px',
}));

export const CancelButton = styled(OutlinedButton)(({ theme }) => ({
  border: `1px solid ${theme.palette.primary.main}`,
  color: theme.palette.primary.main,
  width: 'fit-content',
  padding: '10px 48px',

  '&:hover': {
    backgroundColor: 'transparent',
    color: theme.palette.primary.main,
    filter: 'brightness(85%)',
  },
}));

export const ConfirmButton = styled(FilledButton)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  width: 'fit-content',
  padding: '10px 48px',

  '&:hover': {
    backgroundColor: theme.palette.primary.main,
    filter: 'brightness(85%)',
  },
}));

export const Footnote = styled(Typography)(() => ({
  color: '#475467',
  fontSize: '13px',
  lineHeight: '140%',
  textAlign: 'center',
  marginTop: '24px',
}));
